/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export type NomineeDetailsType = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  relation: string;
  line1: string;
  line2: string;
  pincode: string;
  city: string;
  state: string;
  country: string;
  sharePercentage: string;
  dateOfBirth: string;
};
export interface NomineeDetailsFormState {
  status: 'idle' | 'loading' | 'success' | 'error';
  nomineeDetails: NomineeDetailsType,
  pincodeDetails: any;
  isPincodeValid: {
    [key: string]: boolean;
  };
  nomineeDetailsSkipped: boolean;
  error: {
    isError: boolean,
    type: string | null,
    message: string | null
  }
}

// Initial State

const initialNomineeDetails = {
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  relation: '',
  line1: '',
  line2: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
  sharePercentage: '',
  dateOfBirth: '',
};
const initialState: NomineeDetailsFormState = {
  status: 'idle',
  nomineeDetails: initialNomineeDetails,
  pincodeDetails: {},
  isPincodeValid: {},
  nomineeDetailsSkipped: false,
  error: {
    isError: false,
    type: null,
    message: '',
  },
};

export const nomineeDetailsFormSlice = createSlice({
  name: 'nomineeDetailsForm',
  initialState,
  reducers: {
    saveNomineeDetails: (state, action) => {},
    setSavedNomineeDetails: (state, action) => {
      state.nomineeDetails = action.payload;
      state.status = 'success';
    },
    skipNomineeDetails: (state, action) => {},
    setSkipNomineeDetails: (state, action) => {
      state.nomineeDetailsSkipped = action.payload;
      state.status = 'success';
    },
    fetchPincodeInfo: (state, action) => {},
    setPincodeInfo: (state, action) => {
      const { pincode } = action.payload;
      if (action.payload.error) {
        state.isPincodeValid = { ...state.isPincodeValid, [pincode]: false };
      } else {
        state.isPincodeValid = { ...state.isPincodeValid, [pincode]: true };
        state.pincodeDetails[action.payload.pincodeDetails.pincode] = action.payload.pincodeDetails;
      }
      state.status = 'idle';
    },
    clearNomineeDetails: (state) => {
      state.nomineeDetails = initialNomineeDetails;
    },
    setNomineeDetailsFormError: (state, action) => {
      state.error = action.payload;
      state.status = 'error';
    },
    setNomineeDetailsFormStatus: (state, action) => {
      state.status = action.payload;
    },
    clearNomineeDetailsFormError: (state) => {
      state.error = {
        isError: false,
        type: null,
        message: '',
      };
      state.status = 'idle';
    },
  },
});

// Actions
export const {
  clearNomineeDetails, saveNomineeDetails, setSavedNomineeDetails,
  setNomineeDetailsFormError, setNomineeDetailsFormStatus, clearNomineeDetailsFormError,
  fetchPincodeInfo, setPincodeInfo, setSkipNomineeDetails, skipNomineeDetails,
} = nomineeDetailsFormSlice.actions;

// Slice Reducer
export default nomineeDetailsFormSlice.reducer;
